let ol = require('openlayers');

let GeocodingItem = require('./geocodingItem');
let GeocodingDictionary = require('./../../constants/geocoding');

let SearchResult = require('./../../tasks/searchResult');

class NominatimGeocodingItem extends GeocodingItem {
    constructor(params) {
        super(params);

        // координаты точки
        let lon = Number(params.lon);
        let lat = Number(params.lat);
        let position = [lon, lat];
        this.position = position;

        // координаты описывающего прямоугольника
        let boundingbox = params.boundingbox.map((item) => {
            return Number(item)
        });
        let lowerCorner = [boundingbox[2], boundingbox[0]];
        let upperCorner = [boundingbox[3], boundingbox[1]];

        let extent = {lowerCorner: lowerCorner, upperCorner: upperCorner};
        this.extent = extent;

        // описание найденного геообъекта
        this.address = params.display_name;

        // точность соответствия поиска
        this.precision = "";
        this.kind = "";

        this.layerId = "Nominatim:Geocoder";
    }

    /**
     * Приводит результат геокодинга к классу SearchResult
     * @return {SearchResult} - результат геокодирования
     */
    getSearchResult() {
        let self = this;
        let attributes = {
            address: self.address,
            precision: self.precision,
            kind: self.kind
        };

        let geometry = new ol.geom.Point(ol.proj.fromLonLat(self.position));

        let result = new SearchResult({
            layerId: self.layerId,
            layerName: self.layerId,
            queryGeometry: geometry,
            geometry: geometry,
            attributes: attributes,
            preparedAttributes: [
                {
                    name: "address",
                    alias: "Адрес",
                    group: undefined,
                    value: self.address
                },
                {
                    name: "precision",
                    alias: "Оценка геокодирования",
                    group: undefined,
                    value: self.precision
                },
                {
                    name: "kind",
                    alias: "Тип объекта",
                    group: undefined,
                    value: self.kind
                }
            ],
            dirtyData: new ol.Feature({
                geometry: geometry,
                address: self.address,
                precision: self.precision,
                kind: self.kind
            }),
            title: self.address
        });
        return result;
    }
}

module.exports = NominatimGeocodingItem;